import { getResource } from "../api/http";

/** Lives of the app over `days` (Firestore liveSessions, or devliveSessions with env "dev"); rejects on failure. */
export const getLiveSessions = ({ days = 30, env = "prod" } = {}) =>
  getResource(`/api/admin/live-sessions?days=${days}&env=${env}`, { rethrow: true });
